import { ReactElement, ReactNode } from "react";
import { ArrowSwitchIcon, ArrowSwitchCrossIcon } from "../../atoms/Icons";
import tokens from "../../../theme/tokens";
import Logo from "../../atoms/Logo";

export interface IntegrationIconExchangeProps {
  integrationIcon: ReactNode;
  variant?: "connect" | "disconnect";
}

export default function IntegrationIconExchange({
  integrationIcon,
  variant = "connect",
}: IntegrationIconExchangeProps): ReactElement {
  const isDisconnect = variant === "disconnect";

  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center justify-center w-12 h-12 bg-purple-600 rounded-xl">
        <Logo color="white" variant="symbol" height={24} />
      </div>
      <div className="relative">
        {!isDisconnect ? (
          <ArrowSwitchIcon size={24} color={tokens.colors.green[300]} />
        ) : (
          <ArrowSwitchCrossIcon size={24} color={tokens.colors.gray[400]} />
        )}
      </div>
      <div className="flex items-center justify-center w-12 h-12 bg-white rounded-2xl overflow-hidden">
        {integrationIcon}
      </div>
    </div>
  );
}
